import type { i18n } from 'i18next';

const ONE_KB = 1024;
export const ONE_MB = ONE_KB * ONE_KB;
export const ONE_GB = ONE_MB * ONE_KB;

/*
 * See https://tc39.es/ecma402/#table-sanctioned-single-unit-identifiers for list of units
 */
const formatBytes = (i18n: i18n, bytes: number): string => {
  let result;

  if (bytes < ONE_KB) {
    result = {
      value: bytes,
      unit: 'byte',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };
  } else if (bytes < ONE_MB) {
    result = {
      value: bytes / ONE_KB,
      unit: 'kilobyte',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
  } else if (bytes < ONE_GB) {
    result = {
      value: bytes / ONE_MB,
      unit: 'megabyte',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
  } else {
    result = {
      value: bytes / ONE_GB,
      unit: 'gigabyte',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
  }

  return new Intl.NumberFormat(i18n.language ?? 'en', {
    style: 'unit',
    unit: result.unit,
    unitDisplay: 'short',
    minimumFractionDigits: result.minimumFractionDigits,
    maximumFractionDigits: result.maximumFractionDigits,
  }).format(result.value);
};

export default formatBytes;
